// Constants for different requests for current reducer
export default {
  checkpointInfo: 'CHECKPOINT_INFO',
  checkpoints: 'CHECKPOINTS',
};
